import { useNavigate } from "react-router-dom";
import Button from "../../components/button/Button";

const NotFound = () => {
  const navigate = useNavigate();
  return (
    <div className="flex justify-center items-center h-screen flex-col bg-secondary">
      <h1 className="text-6xl m-1 font-normal text-primaryText">404</h1>
      <h2 className="text-3xl text-secondaryText font-normal">
        The page you were looking for doesn't exist
      </h2>
      <Button onClick={() => navigate(-1)}>Go Back</Button>
    </div>
  );
};

export default NotFound;
